import { ThemeConfig } from "antd";
import { componentPalette } from "src/theme/component-palette";

export const antdTheme = (): ThemeConfig => {
  return {
    components: {
      Button: {
        colorPrimary: componentPalette.primary,
        colorPrimaryHover: componentPalette.hover,
      },
      Input: {
        colorPrimary: componentPalette.primary,
      },
      Checkbox: {
        colorPrimary: componentPalette.primary,
      },
      Select: {
        colorPrimary: componentPalette.primary,
        optionSelectedBg: componentPalette.secondary,
      },
      Table: {
        colorPrimary: componentPalette.primary,
        colorFillQuaternary: componentPalette.primary,
        fontSize: componentPalette.fontSize,
      },
      Pagination: {
        colorPrimary: componentPalette.primary,
      },
      Modal: {
        colorPrimary: componentPalette.primary,
        colorBorderSecondary: componentPalette.primary,
        colorPrimaryHover: componentPalette.hover,
      },
      Notification: {
        colorPrimary: componentPalette.primary,
        colorBorderSecondary: componentPalette.primary,
      },
      Spin: {
        colorPrimary: componentPalette.primary,
      },
      Switch: {
        colorPrimary: componentPalette.primary,
      },
      Steps: {
        colorPrimary: componentPalette.primary,
      },
      Message: {
        contentPadding: "9px 10rem 9px 12px",
      },
      Radio: {
        colorPrimary: componentPalette.primary,
        colorBorderSecondary: componentPalette.secondary,
        buttonColor: componentPalette.primary,
        buttonSolidCheckedHoverBg: componentPalette.hover,
      },
    },
  };
};
